import { SubGroup } from './sub-group.model';
import { TestQuotationLine } from './test-quotation-line.model';
import { PackageQuotationLine } from './package-quotation-line.model';
import { CustomerPackage } from './customer-package.model';

export class QuotationCommercialItem {
    quotationName?: string;
    quotationCode?: string;
    isProductQuotation?: boolean;
    isProjectQuotation?: boolean;
    isStructuringQuotationLine?: boolean;
    currencyCode?: string;
    commercialItemSubGroups?: SubGroup[];
    freeQuotationLinesTest?: TestQuotationLine[];
    freeQuotationLinesPackage?: PackageQuotationLine[];
    customerPackages?: CustomerPackage[];
}
